import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Star } from "lucide-react";
import { pricing } from "@/data/mockData";

const ACCENT = {
  aqua: { ring: "ring-aqua/30", dot: "text-aqua", badge: "bg-aqua/10 text-aqua" },
  electric: { ring: "ring-electric", dot: "text-electric", badge: "bg-electric text-white" },
  violet: { ring: "ring-violet/30", dot: "text-violet", badge: "bg-violet/10 text-violet" },
};

export default function PricingCards() {
  const navigate = useNavigate();
  return (
    <div className="grid gap-6 md:grid-cols-3">
      {pricing.map((p, i) => {
        const a = ACCENT[p.accent];
        return (
          <motion.div
            key={p.name}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            className={`relative flex flex-col rounded-3xl border bg-card p-7 ${p.featured ? `ring-2 ${a.ring} shadow-float md:-translate-y-3` : "border-border"}`}
            data-testid={`pricing-${p.name.toLowerCase().replace(/\s/g, "-")}`}
          >
            {p.featured && (
              <span className="absolute -top-3 left-7 inline-flex items-center gap-1 rounded-full bg-electric px-3 py-1 text-xs font-bold text-white">
                <Star className="h-3 w-3 fill-white" /> Most popular
              </span>
            )}
            <p className={`label-caps ${a.dot}`}>{p.name}</p>
            <div className="mt-3 flex items-end gap-1">
              <span className="font-heading text-4xl font-black">{p.price}</span>
              <span className="mb-1 text-sm text-muted-foreground">{p.period}</span>
            </div>
            <p className="mt-1 text-sm text-muted-foreground">{p.tagline}</p>
            <ul className="mt-6 flex-1 space-y-3">
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2 text-sm">
                  <Check className={`mt-0.5 h-4 w-4 shrink-0 ${a.dot}`} /> {f}
                </li>
              ))}
            </ul>
            <button
              onClick={() => navigate("/signup")}
              className={`mt-7 rounded-full px-6 py-3 text-sm font-semibold transition-colors ${p.featured ? "bg-primary text-primary-foreground hover:bg-primary/90" : "border border-border hover:bg-secondary"}`}
            >
              {p.cta}
            </button>
          </motion.div>
        );
      })}
    </div>
  );
}
